import { render, staticRenderFns } from "./TransactionVolumes.vue?vue&type=template&id=0f31498c&scoped=true&"
import script from "./TransactionVolumes.vue?vue&type=script&lang=js&"
export * from "./TransactionVolumes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f31498c",
  null
  
)

export default component.exports